// The student product's navigation — one definition used by the phone bottom bar AND the desktop top tabs.
// Four destinations. Profile is deliberately NOT one of them: the avatar in the header is the profile entry.
export const STUDENT_NAV = [
  { path: '/student/dashboard', label: 'Home', icon: 'home', match: ['/student/dashboard'] },
  { path: '/student/practice', label: 'Practice', icon: 'practice', match: ['/student/practice', '/student/mock', '/student/mistakes', '/student/tests'] },
  { path: '/student/analytics', label: 'Progress', icon: 'progress', match: ['/student/analytics'] },
  { path: '/student/placement', label: 'Placement', icon: 'placement', match: ['/student/placement'] },
];

// Header context: what the top bar says on each screen, and whether it shows a back button instead of the brand.
// `back` is the parent to fall back to when there is no history to go back to (e.g. opened from a deep link).
const CONTEXT = [
  { test: /^\/student\/dashboard/, title: null },
  { test: /^\/student\/practice/, title: 'Practice' },
  { test: /^\/student\/analytics/, title: 'Progress' },
  { test: /^\/student\/placement/, title: 'Placement' },
  { test: /^\/student\/notifications/, title: 'Notifications', back: '/student/dashboard' },
  { test: /^\/student\/feedback/, title: 'Feedback', back: '/student/dashboard' },
  { test: /^\/student\/settings/, title: 'Settings', back: '/student/dashboard' },
  { test: /^\/student\/profile/, title: 'Profile', back: '/student/dashboard' },
  { test: /^\/student\/mistakes/, title: 'Mistake Bank', back: '/student/practice' },
  { test: /^\/student\/mock\/review/, title: 'Review answers', back: '/student/practice' },
  { test: /^\/student\/test\/[^/]+\/review/, title: 'Review answers', back: '/student/practice' },
  { test: /^\/student\/mock/, title: 'Custom practice', back: '/student/practice' },
  { test: /^\/student\/tests/, title: 'Assessments', back: '/student/practice' },
  { test: /^\/student\/ai/, title: 'Coach', back: '/student/dashboard' },
];

export function headerContext(pathname) {
  const hit = CONTEXT.find(c => c.test.test(pathname));
  return hit || { title: null };
}

export const isNavActive = (item, pathname) => item.match.some(m => pathname === m || pathname.startsWith(m + '/'));
